import { render, staticRenderFns } from "./DataCuesGauge.vue?vue&type=template&id=64dce0ba&scoped=true"
import script from "./DataCuesGauge.vue?vue&type=script&lang=js"
export * from "./DataCuesGauge.vue?vue&type=script&lang=js"
import style0 from "./DataCuesGauge.scss?vue&type=style&index=0&id=64dce0ba&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64dce0ba",
  null
  
)

export default component.exports